var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { EquityDropdown, } from "@frameworks/web/components/generic/equitydropdown/equitydropdown";
import { MFOrderBook } from "../constant";
import DateCalendar from "@frameworks/salesjourney/components/Generic/DateCalendar";
import { futureMonth, getDateInFormat, TodaysDate, } from "@domains/utils/reportDates";
import downloadimg from "@frameworks/shared-library/assets/images/SalesJourney/download-img.svg";
import moment from "moment";
import { useSelector } from "react-redux";
import di from "../di/serviceLocator";
import Loader from "../../../../../shared-library/components/Loader";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import Spinner from "react-bootstrap/Spinner";
import InputField from "@frameworks/web/components/generic/inputField";
var MfSipOrderBook = function (props) {
    var _a = useSelector(function (state) { return state.Clients.MFOrderBook; }), mfOrderBookData = _a.reducersData, MFcommonData = _a.commonData;
    var _b = __read(React.useState(""), 2), searchText = _b[0], setSearchText = _b[1];
    var _c = __read(React.useState(), 2), searchResultData = _c[0], setSearchResultData = _c[1];
    var _d = __read(useState(false), 2), downloadMFOrderBookLoader = _d[0], setDownloadMFOrderBookLoader = _d[1];
    var columnList = [
        "Account Code",
        "Trade Date ",
        "Scheme Name",
        "Buy Self ",
        "Price",
        "NAV",
        "Unit",
        "Remarks",
        "Exchange Status",
        "Exchanges",
    ];
    var _e = __read(useState(MFOrderBook[0]), 2), mfSipRegistration = _e[0], setMFSipRegistration = _e[1];
    var _f = __read(React.useState(true), 2), showWeek = _f[0], setShowWeek = _f[1];
    var _g = __read(useState({}), 2), finalFilterState = _g[0], setFinalFilterState = _g[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    React.useEffect(function () {
        mfOrderBookAPIData("All");
    }, []);
    var mfOrderBookAPIData = function (dropdownselectedvalue) {
        di.clients.getMFOrderBookData({
            acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            status: dropdownselectedvalue,
        });
    };
    var getSearchDataFromWithinData = function (searchText) {
        var _a, _b;
        setSearchText(searchText);
        var searchResultData = [];
        if (mfOrderBookData &&
            (mfOrderBookData === null || mfOrderBookData === void 0 ? void 0 : mfOrderBookData.data) &&
            ((_a = mfOrderBookData === null || mfOrderBookData === void 0 ? void 0 : mfOrderBookData.data) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            !!searchText &&
            searchText !== "") {
            (_b = mfOrderBookData === null || mfOrderBookData === void 0 ? void 0 : mfOrderBookData.data) === null || _b === void 0 ? void 0 : _b.map(function (record) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                if (((_a = record.schemeName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_c = (_b = record.acCode) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_d = record.buySell) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_e = record === null || record === void 0 ? void 0 : record.price) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_f = record === null || record === void 0 ? void 0 : record.nav) === null || _f === void 0 ? void 0 : _f.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_g = record === null || record === void 0 ? void 0 : record.unit) === null || _g === void 0 ? void 0 : _g.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_h = record === null || record === void 0 ? void 0 : record.remarks) === null || _h === void 0 ? void 0 : _h.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_j = record === null || record === void 0 ? void 0 : record.exchangeStatus) === null || _j === void 0 ? void 0 : _j.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_k = record === null || record === void 0 ? void 0 : record.exchange) === null || _k === void 0 ? void 0 : _k.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_l = record === null || record === void 0 ? void 0 : record.tradeDate) === null || _l === void 0 ? void 0 : _l.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase()))) {
                    searchResultData.push(record);
                }
            });
        }
        setSearchResultData(searchResultData);
    };
    var downloadApiResponse = function (selectedStatus) {
        setDownloadMFOrderBookLoader(true);
        if (selectedStatus && selectedStatus !== "") {
            di.clients
                .getMFOrderBookData({
                acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                status: selectedStatus,
                downloadFlag: true,
            })
                .then(function (resp) {
                if (resp && resp !== "") {
                    base64toExcel(resp, "MF_ORDER_BOOK" +
                        getDateInFormat(new Date(), "DD_MM_YYYY") +
                        ".xlsx");
                }
                setDownloadMFOrderBookLoader(false);
            })
                .catch(function (error) {
                setDownloadMFOrderBookLoader(false);
            });
        }
        else {
            setDownloadMFOrderBookLoader(false);
        }
    };
    var getIterationCondition = function () {
        var _a;
        var allowTrue = false;
        if (!!searchText &&
            searchText !== "" &&
            searchResultData &&
            (searchResultData === null || searchResultData === void 0 ? void 0 : searchResultData.length) > 0) {
            allowTrue = true;
        }
        else if ((searchText === "" || searchText === undefined || searchText === null) &&
            mfOrderBookData &&
            (mfOrderBookData === null || mfOrderBookData === void 0 ? void 0 : mfOrderBookData.data) &&
            ((_a = mfOrderBookData === null || mfOrderBookData === void 0 ? void 0 : mfOrderBookData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            allowTrue = true;
        }
        return allowTrue;
    };
    var getIterationMappedData = function () {
        var data = mfOrderBookData.data;
        if (searchResultData &&
            !!searchText &&
            searchText !== "" &&
            (searchResultData === null || searchResultData === void 0 ? void 0 : searchResultData.length) > 0) {
            data = searchResultData;
        }
        return data;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mf-registration pastinteraction-main-block container px-0" },
            React.createElement(Row, { className: "m-0" },
                React.createElement(Col, { lg: 12 },
                    React.createElement("nav", { className: "generic-breadcrumb container p-0 viewall-breadcrumb" },
                        React.createElement("ol", { className: "breadcrumb" },
                            React.createElement("li", { className: "breadcrumb-item EncodeSans_12_500 txt_secondary-gray hand_cursor", onClick: function () { return props === null || props === void 0 ? void 0 : props.closeSip(false); } }, "Reports"),
                            React.createElement("li", { className: "breadcrumb-item EncodeSans_12_500 active hand_cursor" }, "MF SIP Order Book"))))),
            React.createElement(Row, { className: "m-0" },
                React.createElement(Col, { lg: 12, className: "date-calender-sip" },
                    React.createElement(DateCalendar, { setFinalFilterState: setFinalFilterState, weeklyFirst: showWeek, todaysDate: true, setShowWeekFlag: setShowWeek, ToDatemax: futureMonth(TodaysDate, 6), isMinDate: true, fromDate: getDateInFormat(moment().startOf("isoWeek").toDate(), "YYYY/MM/DD"), toDate: getDateInFormat(moment().endOf("isoWeek").toDate(), "YYYY/MM/DD") }))),
            React.createElement(Row, { className: "m-0" },
                React.createElement(Col, { lg: 12, className: "d-flex align-items-center justify-content-end mt-20" },
                    React.createElement("div", null,
                        React.createElement(InputField, { placeholderClassName: "", prefix: React.createElement("i", { className: "edel-icon-search1" }), className: "filter-search ps-2 input-group input-group-with-search filter-serach-gray", placeholder: "Search", defaultValue: searchText, onChangeEvent: function (e) {
                                console.log("changes");
                                getSearchDataFromWithinData(e.target.value);
                            } })),
                    React.createElement("div", { className: "d-flex align-items-center mx-3 DMSanM_14_500" },
                        React.createElement("label", null, "Select Status"),
                        React.createElement(EquityDropdown, { itemlist: MFOrderBook, defaultVal: true, selectedDefaultVal: mfSipRegistration, selectedValue: function (e) {
                                setMFSipRegistration(e);
                                mfOrderBookAPIData(e.value);
                            }, externalClassname: "common-drp-not-brd" })),
                    React.createElement("div", null,
                        React.createElement("div", { className: "download-btn" },
                            React.createElement("button", { className: "btn  downloads justify-content-between", onClick: function () {
                                    downloadApiResponse(mfSipRegistration === null || mfSipRegistration === void 0 ? void 0 : mfSipRegistration.value);
                                } },
                                React.createElement(React.Fragment, null, downloadMFOrderBookLoader ? (React.createElement(Spinner, { animation: "border", variant: "primary", size: "sm" })) : (React.createElement("img", { className: "", src: downloadimg }))),
                                React.createElement("span", { className: "DMSanM_14_500 txt-midnight-blue download-txt" }, "Download")))))),
            React.createElement(Row, { className: "m-0" },
                React.createElement(Col, { lg: 12, className: "mt-20" }, (MFcommonData === null || MFcommonData === void 0 ? void 0 : MFcommonData.loader) ? (React.createElement("div", { className: "position-relative client-loader" },
                    React.createElement(Loader, null))) : (React.createElement(Table, { className: "lead-table service-request" },
                    React.createElement("thead", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                        React.createElement("tr", null, columnList.map(function (column, idx) {
                            return React.createElement("th", { key: idx }, column);
                        }))),
                    React.createElement("tbody", { className: "DMSanN_14_400 txt_blackOne1" }, getIterationCondition() ? (React.createElement(React.Fragment, null, getIterationMappedData().map(function (item) {
                        return (React.createElement("tr", { className: "" },
                            React.createElement("td", null, addDashIfNullOrUndefined(item.acCode)),
                            React.createElement("td", null, addDashIfNullOrUndefined(getDateInFormat(item.tradeDate, "DD MMM YYYY"))),
                            React.createElement("td", { className: "ellipsis", title: addDashIfNullOrUndefined(item.schemeName) },
                                React.createElement("span", null, addDashIfNullOrUndefined(item.schemeName))),
                            React.createElement("td", null, addDashIfNullOrUndefined(item.buySell)),
                            React.createElement("td", null, addDashIfNullOrUndefined(item.price)),
                            React.createElement("td", null, addDashIfNullOrUndefined(item.nav)),
                            React.createElement("td", null, addDashIfNullOrUndefined(item.unit)),
                            React.createElement("td", { className: "ellipsis", title: item.remarks },
                                React.createElement("span", null, addDashIfNullOrUndefined(item.remarks))),
                            React.createElement("td", null, addDashIfNullOrUndefined(item.exchangeStatus)),
                            React.createElement("td", null, addDashIfNullOrUndefined(item.exchange)),
                            React.createElement("td", { className: "align-bottom" },
                                React.createElement("i", { className: " edel-icon-arrow-down uparrow" }))));
                    }))) : (React.createElement(React.Fragment, null,
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 12, className: "border-0" },
                                React.createElement(Errormsg, { msg: "No Data Found" })))))))))))));
};
export default MfSipOrderBook;
